import { VimeoFrame } from "src/utils/fw"
import { getDayRow, modalColor } from "../utils"
import { days, Now } from "./keynotes"
import { effect } from "./modals/exploration/dayOne"

function column(left, top = 7.7, width = 29.3, heights = [3.6, 5.6, 7.6]) {
	const lines = []
	let current = top
	this.add = ([link, label = ""], lineNb = 1, onClick=undefined) => { 
		const params = "?badge=0&autopause=0&quality_selector=1&progress_bar=1&player_id=0&app_id=58479&autoplay=1"
		lines.push({
			top: `${current}%`,
			left: `${left}%`,
			modal: <VimeoFrame wrapperStyle={{ backgroundColor: modalColor }} vidId={link.replace(/^\//, "") + params} />,
			width: `${width}%`,
			height: `${heights[lineNb - 1]}%`,
			label,
			onClick
		})

		current += heights[lineNb - 1] + .1

		return this
	}

	this.get = () => {
		return lines;
	}

	return this
}

const columns = [
	6.1, 38.2, 70.2
]

const videos = [
`https://vimeo.com/manage/videos/1020619175/player
https://vimeo.com/manage/videos/1022510928/player
https://vimeo.com/manage/videos/1022458962/player
https://vimeo.com/manage/videos/1022458988/player
https://vimeo.com/manage/videos/1022459011/player
https://vimeo.com/manage/videos/1020907696/player
https://vimeo.com/manage/videos/1020913280/player
https://vimeo.com/manage/videos/1022463784/player
https://vimeo.com/manage/videos/1021022684/player
https://vimeo.com/manage/videos/1023310931/player
https://vimeo.com/manage/videos/1022463843/player
https://vimeo.com/manage/videos/1020903104/player
https://vimeo.com/manage/videos/1022521173/player
https://vimeo.com/manage/videos/1020928454/player`,
`https://vimeo.com/manage/videos/1020933250/player
https://vimeo.com/manage/videos/1020937276/player
https://vimeo.com/manage/videos/1020946798/player
https://vimeo.com/manage/videos/1022503585/player
https://vimeo.com/manage/videos/1022503622/player
https://vimeo.com/manage/videos/1022503664/player
https://vimeo.com/manage/videos/1022503701/player
https://vimeo.com/manage/videos/1021007901/player
https://vimeo.com/manage/videos/1022507863/player
https://vimeo.com/manage/videos/1021013861/player
https://vimeo.com/manage/videos/1022507919/player`,
`https://vimeo.com/manage/videos/1022507936/player
https://vimeo.com/manage/videos/1022513519/player
https://vimeo.com/manage/videos/1022507962/player`
].map(row => row.split("\n").map(it => {
	return RegExp(/\/videos\/(\d+)/).exec(it)[1]
}))

const achIds = [
	"9bbf828d-030a-403b-bb7e-63d3e83c30e0",
	'5d5998c5-7c0c-4c40-adf3-ffaf47b3d61d',
	'14f44133-cfcf-43cb-ae00-a8d22a667b5e',
	'938cd1d8-c88e-4441-a6dd-e5dea99d47a2',
	'a5715c77-40b0-48dd-ae3d-66b68d66f70a',
	'b9bce320-73a2-49da-8c93-99a985842aa9',
	'80385d72-1514-4d11-b822-225973f45b20',
	'bc587a25-f0c7-41d8-83b6-e336a2b64ff9',
	'b983eaf6-5787-4aa0-8537-f27e9b253ec1',
	'8db9fe74-da9f-4bed-885b-96fe2e2fc63e',
	'3d6db635-7f9e-4676-84e3-2d1dcc485b7d',
	'5710fd4e-0e30-4bf7-8405-76766ac7a681',
	'aa900565-8995-4d82-ab2f-3a459d06c648',
	'9afa7c25-9c7f-41c2-8d5d-da79d459f2b3',
	'dcc94774-62ae-49d2-93d9-b4acff3a6e97',
	'ab35bf91-ba13-4fe9-bfc5-14a81f9ee3e1',
	'240a074a-456a-4bae-b7c4-74ce08c06302',
	'e0d998dc-1ba0-4562-9031-074477c1e9b6',
	'35ee91e0-83a2-4029-9053-904e99e39fec',
	'1a34d7e9-cc82-4fe5-ba4c-8a834e63b418',
	'67f9f787-82b2-49fd-a3e6-2f5bb2ce6e0a',
	'07977dba-27ee-4bcd-a045-2015001ec5b8',
	'85e1e130-c24b-48f0-b8f0-2477400fdf13',
	'1da63628-a6e8-4d8d-80d5-cbc9ea7ead63',
	'f83b6fed-825a-4de6-888a-0f00f4f54c11',
	'ce08b3cb-e34c-42f5-8a89-9a421abda54c',
	'9f9bb259-7138-47e0-bef7-be6bbbe369be',
	'2297ae09-8069-4d09-99a7-6e6ad711490f'
]

const sessions = [
	[days[0],`B1.2 Switching Gears to ISO 27001:2022: The upgrade saga you didn't know you needed
B1.3 Diffused Perspectives Virus (DPV): How to fight this highly contagious virus that ruins your awareness programme
B1.4 Looking Beyond Zero Trust to Cybersecurity Mesh Architecture
B2.2 Risk Assessments in OT: The art of cuddling a cactus
B2.4 ThreatLocker: How to Create Successful Malware and Defend with Zero Trust
B3.2 Why is PQC Quantum-Safe, Exactly?
B3.3 Manipulator to Listener: An emotional intelligence (EQ) journey
B3.4 SureCloud: Beyond Monitoring: Integrating continuous control monitoring with GRC for comprehensive cyber resilience
B4.2 Our SOC Transformation Journey: The good, the bad and the ugly
B4.3 Security Leadership Panel: Staying the course
B4.4 ISF Assure – An Introduction
B5.2 The Good, the Bad and the NIS2
B5.3 Risky Business: Building a flexible everyday risk framework
B5.4 Dealing with Risks and Uncertainty: The psychological phenomena that influence your risk assessments`],
[days[1], `B6.2 The Benefits of Implementing a Proactive Deepfake Mitigation Strategy
B6.3 Why are our Teams Burning Out? Lessons learnt to keep the fires at bay
B6.4 Telenor’s Journey into Establishing a Security Threat Intelligence Radar
B7.3 A Gen Z'ers Perspective on Rejuvenating Your Security Workforce
B7.4 SecurityScorecard: Cyber Resiliency in the Supply Chain: Navigating risks amid global disruptions
B8.2 Cyber Crisis: When even 15 minutes can be too long
B8.3 Regulation vs. Innovation: How much is too much?
B8.4 Outsourcing Securely: Essential steps to ensure success
B9.2 Navigating the Future: Unleashing the power of autonomous security
B9.3 Are You Compliant or are You Ready? Surviving an extinction level event
B9.4 A Secure Supply Chain - To be or not to be`],
[days[2], `B10.2 Risk Dashboards: Converting the Board on Cyber Risk in 45 minutes
B10.3 Securing the Supply Chain: A cross-collaborative approach
B10.4  Threat Intelligence: The difference between winning and losing`]
].map(([day, row], d) => {
	const cl = new column(columns[d], undefined, d == 2 ? 24.3 : undefined)

	if (Now() < day) return cl.get()

	const metadata = row.split("\n").map((it, idx) => {
		return [videos[d][idx], it, Math.ceil(it.length / (it.length < 120 ? 60 : 59)), achIds[d]]
	})

	metadata.forEach(dt => {
		cl.add(dt, dt[2], effect(dt[3]))
	})
	return cl.get()
})

const background = () => {
	const now = Now()

    const bgs = [
        [days[0], "https://assets.swoogo.com/uploads/full/4590292-6721475f29aa7.png"],
        [days[1], "https://assets.swoogo.com/uploads/full/4590290-6721475f190db.png"],
        [days[2], "https://assets.swoogo.com/uploads/full/4590291-6721475f18a35.png"]
    ]


    const bg = getDayRow(bgs, ([d]) => d, now)

    return bg[1];
}

export default {
	background: background(),
	links: [
		...sessions.flat(),
		{
			top: `92.6%`,
			left: `42.6%`,
			href: "/atrium",
			width: `14.7%`,
			height: `6%`,
			label: "Back to Atrium"
		}
	]
	,
	name: "breakoutondemand",
}